import {useQuery, useMutation, useQueryClient} from "@tanstack/react-query";
import {useAxiosPrivate} from "../useAxiosPrivate";
import axiosPublic from "../../api/axiosPublic";

export default function useRegisterQueries() {
    const axiosPrivate = useAxiosPrivate();
    const queryClient = useQueryClient();

    // QUERIES ------------------------------------------------------

    const registerSubscriptionQuery = useQuery({
        queryKey: ["register", "subscription"],
        queryFn: () =>
            axiosPrivate
                .get("subscription/")
                .then(r => r.data)
    });

    const registerActivateQuery = useQuery({
        queryKey: ["register", "activate"],
        queryFn: ({queryKey}) => {
            const [, , params] = queryKey;
            return axiosPrivate
                .get("activate/", {params})
                .then(r => r.data);
        },
        enabled: false
    });

    // MUTATIONS ------------------------------------------------------

    const loginMutation = useMutation({
            mutationFn: (data) =>
                axiosPublic
                    .post("/api/token/", data)
                    .then(r => r.data),
        });

    const registerNewMutation = useMutation({
            mutationFn: (data) =>
                axiosPrivate
                    .post("register_new/", data)
                    .then(r => r.data),
            onSuccess: (...args) => {
                queryClient.invalidateQueries(["register"]);
            }
        });

    const registerExistingMutation = useMutation({
            mutationFn: (data) =>
                axiosPrivate
                    .post("register_existing/", data)
                    .then(r => r.data),
            onSuccess: (...args) => {
                queryClient.invalidateQueries(["register"]);
            }
        });

    const registerForBusinessMutation = useMutation({
            mutationFn: (data) =>
                axiosPrivate
                    .post("register_for_business/", data)
                    .then(r => r.data),
            onSuccess: (...args) => {
                queryClient.invalidateQueries(["register"]);
            }
        });

    const registerCardMutation = useMutation({
            mutationFn: (data) =>
                axiosPrivate
                    .post("register_card/", data)
                    .then(r => r.data),
            onSuccess: (...args) => {
                queryClient.invalidateQueries(["register"]);
            }
        });

    const renewSubscriptionMutation = useMutation({
            mutationFn: (data) =>
                axiosPrivate
                    .post("renew-subscription/", data)
                    .then(r => r.data),
            onSuccess: (...args) => {
                queryClient.invalidateQueries(["register"]);
            }
        });

    const payForSubscriptionMutation = useMutation({
            mutationFn: (data) =>
                axiosPrivate
                    .post("pay-for-subscription/", data)
                    .then(r => r.data),
            onSuccess: (...args) => {
                queryClient.invalidateQueries(["register"]);
            }
        });

    return {
        // Queries
        registerSubscriptionQuery,
        registerActivateQuery,

        // Mutations
        registerNewMutation,
        renewSubscriptionMutation,
        registerExistingMutation,
        registerForBusinessMutation,
        registerCardMutation,
        payForSubscriptionMutation,

        loginMutation,
    };
}
